import { GET_FILTERED_PRODUCTS, GET_PRODUCTS, GET_PRODUCTS_DETAIL } from "../ConstAction";

export const getProducts = (data, setLoading) => {
  return {
    type: GET_PRODUCTS,
    data: data,
    setLoading: setLoading
  };
};

export const productDetails = (data, setLoading) => {
  return {
    type: GET_PRODUCTS_DETAIL,
    data: data,
    setLoading: setLoading
  };
};


export const getfilteredProducts = (data, setLoading) => {
  return {
    type: GET_FILTERED_PRODUCTS,
    data: data,
    setLoading: setLoading
  };
};



